import riseOfKobePrintImage from "../../../image/originals/hollywoodicons/kobeprint.webp";
import whitneyHoustonPrintImage from "../../../image/originals/hollywoodicons/whitney.webp";
import princessLeiaPrintImage from "../../../image/originals/hollywoodicons/princessleia.webp";
import leftEyePrintImage from "../../../image/originals/hollywoodicons/lisalefteye.webp";
import audreyBreakfastAtTiffanysPrintImage from "../../../image/originals/hollywoodicons/audreybreakfastprint.webp";
import aaliyahPrintImage from "../../../image/originals/hollywoodicons/aaliyah.webp";
import selenePrintImage from "../../../image/originals/quantum/seleneprint.webp";
import audreyHepburnPrintImage from "../../../image/originals/hollywoodicons/audreyprint.webp";
import marilynMonroePrintImage from "../../../image/originals/hollywoodicons/marilyn.jpg";
import brittanyMurphyPrintImage from "../../../image/originals/hollywoodicons/brittanymurphy.webp";
import princessDianaPrintImage from "../../../image/originals/hollywoodicons/diana.webp";
import basquiatPrintImage from "../../../image/originals/hollywoodicons/basquiatprint.webp";

import Collection from "../Collection";

const HollywoodPrints = () => {
  const items = [
    {
      title: "The Rise of Kobe Art Print",
      imageUrl: riseOfKobePrintImage,
      projectUrl: "/KobePrint",
    },
    {
      title: "Whitney Houston Print",
      imageUrl: whitneyHoustonPrintImage,
      projectUrl: "/WhitneyHoustonPrint",
    },
    {
      title: "Princess Leia Print",
      imageUrl: princessLeiaPrintImage,
      projectUrl: "/PrincessLeiaPrint",
    },
    {
      title: "Left Eye Print",
      imageUrl: leftEyePrintImage,
      projectUrl: "/LeftEyePrint",
    },
    {
      title: "Audrey Hepburn (Breakfast at Tiffanys) Print",
      imageUrl: audreyBreakfastAtTiffanysPrintImage,
      projectUrl: "/AudreyHepburnBreakfastPrint",
    },
    {
      title: "Aaliyah Print",
      imageUrl: aaliyahPrintImage,
      projectUrl: "/AaliyahPrint",
    },
    {
      title: "Selene Print",
      imageUrl: selenePrintImage,
      projectUrl: "/SelenePrint",
    },
    {
      title: "Audrey Hepburn Print",
      imageUrl: audreyHepburnPrintImage,
      projectUrl: "/AudreyHepburnPrint",
    },
    {
      title: "Marilyn Monroe Print",
      imageUrl: marilynMonroePrintImage,
      projectUrl: "/MarilynMonroePrint",
    },
    {
      title: "Brittany Murphy Print",
      imageUrl: brittanyMurphyPrintImage,
      projectUrl: "/BrittanyMurphyPrint",
    },
    {
      title: "Princess Diana Print",
      imageUrl: princessDianaPrintImage,
      projectUrl: "/PrincessDianaPrint",
    },
    {
      title: "Jean-Michel Basquiat Print",
      imageUrl: basquiatPrintImage,
      projectUrl: "/BasquiatPrint",
    },
  ];

  return (
    <Collection
      items={items}
      title="Hollywood Icon Prints"
      variant="boutique"
      eyebrow="Limited Edition Prints"
      description="Limited edition prints celebrating cultural icons, legends, and unforgettable portraits."
      pageClassName="collection-page--prints"
      showFooter
    />
  );
};

export default HollywoodPrints;
